import { boolean } from 'boolean'
import { usePropertiesQuery } from 'hooks/usePropertiesQuery'
import { useUrl } from 'hooks/useUrl'
import { get, pick } from 'lodash'
import { ComponentType } from 'react'
import { useIntl } from 'react-intl'
import { stringifyQueryObject } from 'utils/query'
import { RoleModel } from 'utils/role'
import { Listing } from './listing'
import { Map } from './map'
import { SEO } from './seo'
import { Toolbar } from './toolbar'

const LIMIT = 15

interface Props {
  role?: RoleModel
  category?: any
  zone?: any
}

export const Search: ComponentType<Props> = ({ role, category, zone }) => {
  const { query } = useUrl()
  const { formatMessage } = useIntl()
  const page = Number(get(query, 'page', 1))
  const View = boolean(query.map) ? Map : Listing

  const { loading, data } = usePropertiesQuery({
    variables: {
      query: stringifyQueryObject(
        {
          start: (page - 1) * LIMIT,
          limit: LIMIT,
          role: role?.query,
          category: category?.uuid,
          zone: zone?.uuid,
        },
        pick(query, ['start', 'limit','role', 'category', 'zone', 'places', 'amount>', 'amount<', 'amenities']),
      ),
    },
    notifyOnNetworkStatusChange: true,
  })

  const suptitle = formatMessage(
    {
      id: 'search.suptitle',
    },
    {
      role: role ? formatMessage({ id: role.uuid }) : 'en venta y renta',
      category: category?.pluralName ?? 'Propiedades',
      zone: zone?.name ?? 'Mérida y Yucatán',
    },
  )

  const title = formatMessage(
    {
      id: 'search.title',
    },
    {
      total: data?.properties.total,
      name: category?.name ?? 'Propiedad',
      pluralName: category?.pluralName ?? 'Propiedades',
    },
  )

  return (
    <>
      <SEO category={category} role={role} zone={zone} />
      <Toolbar role={role} />
      <View
        suptitle={suptitle}
        title={title}
        properties={data?.properties.data ?? []}
        total={data?.properties.total ?? 0}
        page={page}
        limit={LIMIT}
        loading={loading}
      />
    </>
  )
}
